import { render, staticRenderFns } from "./turnkey-web.vue?vue&type=template&id=cccf9c94&"
import script from "./turnkey-web.vue?vue&type=script&lang=js&"
export * from "./turnkey-web.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports